import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Button, ButtonVariants } from '../../../../Atoms/Button';
import { useCommunityQACtx } from '../community-context/comment-context';
import loader from '../lottie/loader.json';
import { IContent, IParentProps } from '../utils/types';
import { actionApiCall } from '../utils/utils';

const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
});

export const ActionDisclaimer = ({
  actionBtn,
  setDisplayActionModal,
  commentId,
  replies,
  setReplies,
  content,
  setCommentContent,
}: {
  content?: IContent;
  setCommentContent?: (value: IContent) => void;
  actionBtn: string;
  setDisplayActionModal: (value: boolean) => void;
  commentId: number;
  replies?: IParentProps;
  setReplies?: (value: IParentProps) => void;
}) => {
  const { parentComment, setParentComment } = useCommunityQACtx();
  const [isLoading, setIsLoading] = useState(false);
  const ctxObject = {
    parentComment,
    setParentComment,
    replies,
    setReplies,
    setIsLoading,
  };

  const handleAction = () => {
    setIsLoading(true);

    actionApiCall(
      actionBtn,
      commentId,
      setDisplayActionModal,
      ctxObject,
      content,
      setCommentContent
    );
  };

  return (
    <div
      className="flex px-9 py-11 gap-6 items-center sm:flex-col relative justify-center"
      data-testid={`${actionBtn.toLowerCase()}-comment`}
    >
      <p className="text-s-20 font-semibold text-font-500">
        Do you want to {actionBtn.toLowerCase()} comment?
      </p>
      <div className="gap-6 flex">
        <Button
          variant={ButtonVariants.bluebordered}
          rounded="md"
          className="py-3.5 w-[156px] sm:w-[112px] ml-6"
          onClick={handleAction}
        >
          {actionBtn}
        </Button>
        <Button
          variant={ButtonVariants.bluebordered}
          rounded="md"
          className="py-3.5 w-[156px] sm:w-[112px]"
          onClick={() => setDisplayActionModal(false)}
        >
          Cancel
        </Button>
      </div>
      <div
        className={`px-9 py-11 bg-white rounded-md border outline-none absolute top-0 w-full h-full flex justify-center items-center border-none ${
          isLoading ? 'block' : 'hidden'
        }`}
      >
        <Lottie animationData={loader} loop={true} className="h-32 w-32" />
      </div>
    </div>
  );
};
